import BrandedSuccessLottie from "@/components/ui/BrandedSuccessLottie";
import PageTransition from "@/components/ui/PageTransition";
import { Link, useLoaderData, useNavigate } from "@tanstack/react-router";
import { ArrowRightIcon, PlusIcon, XIcon } from "lucide-react";
import React from "react";
import { Button, buttonVariants } from "../../ui/button/button";

interface CardSuccessPageProps {
	onAddNewCard: () => void;
}

const CardSuccessPage: React.FC<CardSuccessPageProps> = ({ onAddNewCard }) => {
	const navigate = useNavigate();
	const { name } = useLoaderData({ from: "__root__" });

	return (
		<PageTransition>
			<div className="">
				<XIcon
					className="absolute right-0 -top-2"
					role="button"
					onClick={() =>
						navigate({
							to: "/main/card",
						})
					}
				/>
				<div className="max-w-64 mx-auto ">
					<BrandedSuccessLottie />
				</div>

				<div className="w-full text-center">
					<h1 className="text-4xl font-bold text-textDark">
						Card added successfully!
					</h1>
					<p className="pt-3 text-sm font-medium text-textDark pb-9">
						You've added a new card to {name}.
					</p>
				</div>
				<div className="flex flex-col w-full gap-2">
					<Button onClick={onAddNewCard}>
						<PlusIcon className="w-5 h-5" />
						Add new card
					</Button>
					<Link
						to={"/main/deposit"}
						className={buttonVariants({
							variant: "secondary",
							size: "default",
							weight: "bold",
						})}
					>
						Deposit Funds
						<ArrowRightIcon className="w-5 h-5" />
					</Link>
				</div>
			</div>
		</PageTransition>
	);
};

export default CardSuccessPage;
